import withWidth from '@material-ui/core/withWidth';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import OntologyIcon from '../core/icons/Ontology';
import DatasetIcon from '../core/icons/Dataset';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import { Breadcrumbs } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { globalStyles as styles } from '../core/style/gstheme';
import { processHashLocation } from '../core/utils/utils';
import Crumb from './Crumb';
import GS from '../grafsync/grafsync';

class BreadcrumbGenerator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bc: []
        };
    }

    static getDerivedStateFromProps(props) {
        const paramsMap = processHashLocation(props.location);
        const newBCstate = [];
        props.breadcrumb.path && props.breadcrumb.path.forEach(part => {
            if (paramsMap.has(part)) {
                newBCstate.push({
                    name: part,
                    value: paramsMap.get(part)
                });
            }
        });
        return {
            bc: newBCstate
        };
    }

    jumpTo = (application) => {
        const link = GS.getStore(application);
        this.props.history.push(link);
    };

    render() {

        const { bc } = this.state;
        const { classes, breadcrumb, graph, includeJumps, width } = this.props;
        const omLastViewed = GS.getStore("om");
        const vmLastViewed = GS.getStore("vm");
        const dmLastViewed = GS.getStore("dm");

        return (
            <div
                role="navigation"
                aria-label="Quick navigation"
                id="all-navigation"
                style={{ display: 'flex' }}>
                {includeJumps &&
                    <div style={{
                        marginTop: 6,
                        marginRight: 24,
                        height: 36,
                        padding: '0px 12px 0px 0px',
                        borderRight: 'solid 3px #e5e5e5'
                    }}>
                        <span style={{ marginRight: 12 }} data-test="jump-to-taxonomy">
                            <Tooltip title="Jump to Vocabulary Manager last viewed" placement="right">
                                <span>
                                    <IconButton
                                        disabled={vmLastViewed === undefined}
                                        size="small"
                                        aria-label="Jump to Vocabulary Manager last viewed"
                                        style={{
                                            color: vmLastViewed === undefined ?
                                                '#c0c0c0'
                                                :
                                                '#0066CC'
                                        }}
                                        onClick={() => this.jumpTo('vm')}>
                                        <BubbleChartIcon data-test="scheme-icon" fontSize="small" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </span>
                        <span style={{ marginRight: 12 }} data-test="jump-to-ontology">
                            <Tooltip title="Jump to Ontology Manager last viewed" placement="right">
                                <span>
                                    <IconButton
                                        disabled={omLastViewed === undefined}
                                        aria-label="Jump to Ontology Manager last viewed"
                                        size="small"
                                        style={{
                                            color: omLastViewed === undefined ?
                                                '#c0c0c0'
                                                :
                                                '#0066CC'
                                        }}
                                        onClick={() => this.jumpTo('om')}>
                                        <OntologyIcon data-test="ontology-icon" fontSize="small" iconColor={omLastViewed === undefined ?
                                            '#c0c0c0'
                                            :
                                            '#0066CC'} />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </span>
                        <span data-test="jump-to-dataset">
                            <Tooltip title="Jump to Data Manager last viewed" placement="right">
                                <span>
                                    <IconButton
                                        disabled={dmLastViewed === undefined}
                                        aria-label="Jump to Data Manager last viewed"
                                        size="small"
                                        style={{
                                            color: dmLastViewed === undefined ?
                                                '#c0c0c0'
                                                :
                                                '#0066CC'
                                        }}
                                        onClick={() => this.jumpTo('dm')}>
                                        <DatasetIcon data-test="dataset-icon" fontSize="small" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </span>
                    </div>
                }
                {width !== "xs" && width !== "sm" &&
                    <Breadcrumbs
                        aria-label="Breadcrumb navigation"
                        className={classes.breadcrumb}
                        separator={<NavigateNextIcon style={{ color: '#616161', fontSize: '14px' }} />}>
                        <span data-test="start-crumb" className={classes.crumb}>
                            <Link aria-label="Go to start" component={RouterLink} className={classes.linkText} to="/">Start</Link>
                        </span>
                        <span data-test="app-crumb" className={classes.crumb}>
                            <Link
                                aria-label={"Go to " + breadcrumb.title}
                                component={RouterLink}
                                className={classes.linkText}
                                to={breadcrumb.baseURL}>{breadcrumb.title}</Link>
                        </span>
                        {graph && bc.map((item, index) => {
                            const urlPart = breadcrumb.url[item.name];
                            let hashPart = [];
                            for (let i = 0; i <= index; i++) {
                                hashPart.push(bc[i].name + "=" + bc[i].value);
                            }
                            return <Crumb
                                dataTest={"crumb-" + index}
                                id={item.value}
                                graph={graph}
                                handleNotAvailable={true}
                                key={item.value}
                                url={urlPart + "#" + hashPart.join('&')} />;
                        })}
                        <span data-test="static-crumb" className={classes.crumb}>
                            {breadcrumb.static !== undefined ? breadcrumb.static : null}
                        </span>
                    </Breadcrumbs>
                }
            </div>
        );
    }
}

BreadcrumbGenerator.defaultProps = {
    includeJumps: false
};

BreadcrumbGenerator.propTypes = {
    breadcrumb: PropTypes.object.isRequired,
    includeJumps: PropTypes.bool,
    location: PropTypes.object,
    graph: PropTypes.string,
    classes: PropTypes.object
};

export default withRouter(withWidth()(withStyles(styles)(BreadcrumbGenerator)));